import { render, staticRenderFns } from "./PageProgressBar.vue?vue&type=template&id=1baa1f1a&"
import script from "./PageProgressBar.vue?vue&type=script&lang=js&"
export * from "./PageProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./PageProgressBar.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports